<script>
const axios = require("axios");

// const prodEnvironment = require('@/config/prod.env.js').default;
// const devEnvironment = require('@/config/dev.env.js').default;
import session from "./session.vue";

// let serverUrl = devEnvironment.ROOT_API;

// if (process.env.NODE_ENV == "production") {
// 	serverUrl = prodEnvironment.ROOT_API;
// }

let serverUrl = 'https://api.japanparts.com.br/api/';

export default {
  send: async function(url, data, sendToken = false,  method) {

    // send: async function(apiName, command, data, sendToken = false) {
    // 	console.log("server url", serverUrl);
    // 	console.log("root api", process.env.ROOT_API || "root api undefined");
    // let config = {
    // 	url: `${serverUrl}/v1/${apiName}/${command}`,
    // 	method: "post",
    // 	withCredentials: true,
    // 	data: {
    // 		data: data
    // 	}
		// };


    let config = {
      url: url,
      method: method,
      withCredentials: false,
      // data: {
      data: data
			// }

		};


    if (sendToken) {
      let token = session.getItem("token");
      config.data.token = token;
      // config.headers =  {'Accept': "application/json "};
			// config.headers =  {'Authorization': "bearer " + token};
    }

    try {
      const response = await axios.request(config);
      return response.data;
    } catch (error) {
      if (error.message === "Network Error") {
        throw Error("API_CONNECTION_ERROR");
      }

      switch (error.response.status) {
        case 401:
          session.clear();
          throw Error("API_UNAUTHORIZED");
        // window.vueRouter.push('/');
        // return;
        case 403:
          if (error.response.data && error.response.data.error) {
            throw Error(error.response.data.error);
          }
          throw Error("API_FORBIDDEN"); // user does not have correct privileges
        case 404:
          throw Error("API_NOT_FOUND");
        case 413:
          throw Error("API_REQUEST_TOO_LARGE");
        case 429:
          throw Error("API_RATE_LIMIT");
        case 500:
          throw Error("API_SERVER_ERROR");
        default:
          console.error(error);
          throw error.response.data;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/api/request.vue